(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["category-tree"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const toggleButtons = document.querySelectorAll('.category-toggle');

    toggleButtons.forEach((button) => {
      button.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const item = this.closest('.category-item');
        const isExpanded = this.getAttribute('aria-expanded') === 'true';

        this.setAttribute('aria-expanded', String(!isExpanded));
        item.classList.toggle('expanded');
      });
    });

    const activeLinks = document.querySelectorAll('.category-link.active');
    activeLinks.forEach((activeLink) => {
      let parent = activeLink.closest('.category-item');
      while (parent) {
        const toggle = parent.querySelector('.category-toggle');
        if (toggle) {
          toggle.setAttribute('aria-expanded', 'true');
          parent.classList.add('expanded');
        }
        parent = parent.parentElement?.closest('.category-item');
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
